import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';

export function getDealerDetailsSearchResultsUrl(locationId, inventoryType, makeModel = {}) {
  const requestParameters = {
    dealerlocationid: locationId,
    inventorytype: inventoryType,
    make: makeModel.make,
    model: makeModel.model,
  };
  return srpLinkBuilder(requestParameters);
}
